import { CoreStatusView } from '@components'
import { formatCurrencyForDisplay } from '@utils'
import cn from 'classnames'
import { useCurrencies } from 'mmfintech-backend-api'
import type {
  TransactionDirection,
  TransactionDocumentRequestDetails,
  TransactionStatus
} from 'mmfintech-backend-api/types'
import { fetchLastChunk, formatFloat, tr } from 'mmfintech-commons'
import moment from 'moment'
import TransactionTypeWithIcon from './TransactionTypeWithIcon'

import './LatestTransactions.scss'

const LatestTransaction = ({
  reqTime,
  amount,
  currency,
  direction,
  status,
  trnTypeLocalizationKey,
  transactionCategory,
  cardPaymentDetails,
  documentRequest
}: {
  reqTime?: string
  amount?: number
  currency?: string
  direction?: TransactionDirection
  status?: TransactionStatus
  trnTypeLocalizationKey?: string
  transactionCategory?: string
  cardPaymentDetails?: any
  documentRequest?: TransactionDocumentRequestDetails
}) => {
  const { getCurrencyPrecision } = useCurrencies()
  const isCardView = !!cardPaymentDetails
  const { posMerchantName, description } = cardPaymentDetails || {}

  return (
    <div className='recent-transaction-details'>
      <div className='recent-transaction-section'>
        <TransactionTypeWithIcon
          transactionType={
            isCardView
              ? posMerchantName || description
              : tr(trnTypeLocalizationKey, fetchLastChunk(trnTypeLocalizationKey))
          }
          category={transactionCategory}
          description={moment(new Date(reqTime)).format('DD/MM/YYYY H:mm')}
        />
      </div>
      {/* {isCardView && <div className='recent-transaction-desc'>{posMerchantName || description}</div>} */}
      <div data-test='recent-transaction-amount' className='recent-transaction-amount'>
        <div className={cn({ cancelled: status === 'CANCELLED' })}>
          {formatFloat(amount * (direction === 'WITHDRAW' ? -1 : 1) || 0, getCurrencyPrecision(currency))}
          <span className='recent-transaction-amount-currency'>{formatCurrencyForDisplay(currency)}</span>
        </div>
        {
          // isCardView
          //   ? <div className='recent-transaction-name'>{tr(trnTypeLocalizationKey, fetchLastChunk(trnTypeLocalizationKey))}</div>
          //   :
          <CoreStatusView
            status={status}
            label={
              documentRequest ? tr('FRONTEND.TRANSACTIONS.DOCUMENT_REQUEST.STATUS_LABEL', 'Doc Required') : undefined
            }
          />
        }
      </div>
    </div>
  )
}

export default LatestTransaction
